module.exports = __webpack_public_path__ + "static/08-050a9a6b67ef92739ae079d36fcbf514.jpg";